import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AreaProgramaFormacaoService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all AreaProgramaFormacao
  list(params?: any): Observable<any> {
    return this.apiService
      .get<{ data: any[] }>(
        `${this.path}/GetAllAreaProgramaFormacao`,
        params
          ? new HttpParams({
              fromObject: params,
            })
          : this.params
      )
      .pipe(map((response) => response));
  }

  // Create new AreaProgramaFormacao
  public store(form: any): Observable<any> {
    const areaProgramaFormacao = form;
    return this.apiService
      .post<{ object: any }>(
        `${this.path}/AddAreaProgramaFormacao`,
        areaProgramaFormacao
      )
      .pipe(map((response) => response.object));
  }

  // Update existing AreaProgramaFormacao
  public update(form: FormGroup, id: string): Observable<any> {
    const areaProgramaFormacao = form.value;
    return this.apiService
      .put<{ object: any }>(
        `${this.path}/UpdateAreaProgramaFormacao/${id}`,
        areaProgramaFormacao
      )
      .pipe(map((response) => response.object));
  }

  // Delete existing AreaProgramaFormacao
  delete(id: string): Observable<any> {
    return this.apiService.delete(
      `${this.path}/DeleteAreaProgramaFormacaoById/${id}`
    );
  }

  // Get AreaProgramaFormacao by ID
  public show(id: string): Observable<any> {
    return this.apiService
      .get<{ object: any }>(`${this.path}/GetAreaProgramaFormacaoById/${id}`)
      .pipe(map((response) => response.object));
  }

  // Add AreaProgramaFormacao array
  public addAreaProgramaFormacaoArray(data: any): Observable<any> {
    return this.apiService
      .post<{ objects: any[] }>(
        `${this.path}/AddAreaProgramaFormacaoArray`,
        data
      )
      .pipe(map((response) => response.objects));
  }
}
